// import { loginRequest,msalConfig } from '../app/components/Auth/mslconfig/MslConfig';
// import {
//     PublicClientApplication,
//     IPublicClientApplication,
//     Configuration,
//     AccountInfo,
//     EndSessionRequest,
// } from '@azure/msal-browser';
// import { AuthenticationResult } from '@azure/msal-common';
// import { AADStorage, TokenType } from './aad.storage';

//import { loginRequest } from '../app/components/Auth/mslconfig/MslConfig';
import { AADStorage } from "./aad.storage";
import { MIDDLE_WARE_BASE_URL_v1, CALL_PPOR_API, BASE_URL, PROFILE_ERROR } from "./CONSTANTS"; //NON_SSO_LOGIN_REFRESH_TOKEN_API
import jwt_decode from "jwt-decode";
import axios from "axios";

//let REQUEST_SCOPE=process.env.REACT_APP_REQUEST_SCOPE?process.env.REACT_APP_REQUEST_SCOPE:"";

// export const handleLoginPopup = (instance: IPublicClientApplication) => {
//     return instance.acquireTokenPopup(loginRequest);
// };

// export const handleLoginRedirect = (instance: IPublicClientApplication) => {
//     instance.loginRedirect(loginRequest);
// };

// export const getInstance = (iconfig?: Configuration) => {
//     const config = iconfig ? { ...msalConfig, ...iconfig } : msalConfig;
//     return new PublicClientApplication(config);
// };

/* export const handleLoginRedirect = (instance) => {
  console.log("handleLoginRedirect   ", instance);
  instance.loginRedirect(loginRequest);
}; */

export const showLoader = () => {
  const node = document.querySelector(".divSpinner");
  node.removeAttribute("style");
};

export const hideLoader = () => {
  const node = document.querySelector(".divSpinner");
  node.style.display = "none";
};

// export const acquireTokenSilent = async (
//     instance: IPublicClientApplication,
//     accounts: AccountInfo[], isTokenRefresh : boolean = false
// ): Promise<AADStorage | Error> => {
//     const accessTokenRequest = {
//         scopes: [REQUEST_SCOPE],
//         account: accounts[0],
//     }
//     let result: AADStorage | Error;

//     try {

//         const resultToken: AuthenticationResult =
//             await instance.acquireTokenSilent(accessTokenRequest);
//             if(!isTokenRefresh){
//             await setLoginAudit("Bearer "+ resultToken.accessToken + '',"Login");
//             }
//             const tokenType: TokenType = {
//             accessToken: resultToken.accessToken,
//             expiresOn: resultToken.expiresOn,
//             account: resultToken.account,
//         };

//         result = new AADStorage();
//         result.set(tokenType);
//         return Promise.resolve(result);
//     } catch (error) {
//         logout(instance,accounts);
//         return Promise.reject(new Error());
//     }
// };

export const setLoginAudit = async (accessToken, action) => {
  if (accessToken) {
    // OIDC: identity claims (email, name, etc.) live in id_token, NOT access_token.
    // PingOne access tokens carry only authorization context (scope, sub, aud).
    // Read identity from IdToken; fall back to access token if not present (legacy paths).
    const idToken = localStorage.getItem("IdToken");
    const identitySource = idToken ? idToken : accessToken.replace(/^Bearer\s+/i, "");
    let email = null;
    try {
      const decoded = jwt_decode(identitySource);
      email =
        decoded.email ||
        decoded.preferred_username ||
        decoded.upn ||
        decoded.sub ||
        null;
    } catch (e) {
      console.warn("setLoginAudit: failed to decode identity token", e);
    }

    const data = {
      action: action,
      emailID: email,
    };

    let req = JSON.stringify(data).toString();
    const replaceStr = /"/gi;
    req = req.replace(replaceStr, '\\"');
    req = '"' + req + '"';
    const headers = {
      "Content-Type": "application/json",
      // Use IdToken for identity (matches the interceptor in http-utils.ts).
      Authorization: localStorage.getItem("IdToken")
        ? "Bearer " + localStorage.getItem("IdToken")
        : accessToken,
    };
    showLoader();
    const response = await axios
      .post(MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(), req, {
        headers: headers,
      })
      .then(function (response) {
        // Guard against backend returning {data:null} (happens when PingOne
        // doesn't carry email claim and backend rejects the audit payload).
        const responseRaw = response?.data?.result?.data?.response;
        if (!responseRaw) {
          console.warn("setLoginAudit: backend returned no response.data.result.data.response", response?.data);
          // SSO sign-in with no resolvable payload → show the profile-error screen
          // instead of silently leaving the user on a blank Home.
          if (action === "Login") {
            window.location.replace(window.location.origin + "/" + PROFILE_ERROR);
          }
          return null;
        }
        let json = JSON.stringify(responseRaw);
        json = json.replace(/\\"/gi, '"').replace('"{', "{").replace('}"', "}");
        const parsed = JSON.parse(json)?.response;
        const resolvedOracleId = parsed?.oracleID;
        // SSO succeeded but no active employee matched this identity (backend reason
        // "employee_not_found") → route to the profile-error screen, don't blank Home.
        if (
          action === "Login" &&
          (resolvedOracleId === undefined ||
            resolvedOracleId === null ||
            resolvedOracleId === "")
        ) {
          console.warn("setLoginAudit: no oracleID resolved for SSO identity", parsed?.reason);
          window.location.replace(window.location.origin + "/" + PROFILE_ERROR);
          return null;
        }
        localStorage.setItem("oracleId", resolvedOracleId);
        localStorage.setItem("UserRole", parsed?.userRole);
        window.location.reload();
        return resolvedOracleId;
      })
      .catch(function (error) {
        console.error("setLoginAudit failed:", error?.response?.data || error);
        // Don't throw — audit failure shouldn't block login.
        return null;
      });
    hideLoader();
    return response;
  }
};

/* export const logout = (
  instance: IPublicClientApplication,
  accounts: AccountInfo[]
) => {
  const sessionRequest: EndSessionRequest = {
    account: accounts[0],
    postLogoutRedirectUri: "/",
  };
  setLoginAudit(localStorage.getItem("AccessToken"), "Logout");
  const aadStogare: AADStorage = new AADStorage();
  aadStogare.clear();
  instance.logoutRedirect(sessionRequest);
}; */

// export const refreshToken = async(): Promise<any> => {
//   const token : any = localStorage.getItem("AccessToken-NonSSO");
//   if(token)
//   {
//   const decodedToken : any =  jwt_decode(token);
//   if(decodedToken.Type === "TNS")
//   {
//   let date = new Date("1970-01-01 00:00:00:000");
//   date.setSeconds(date.getSeconds() + decodedToken.exp);
//   const dateString = date.toISOString();
//   const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
//   const localDate = new Date(dateString);
//   const utcDate = new Date(localDate.getTime() - userOffset);
//   const currentDateTime = new Date();
//   const tokenExpDateTime = new Date(utcDate);
//   var isTokenExpired = (currentDateTime >= tokenExpDateTime);
//   if(isTokenExpired){
//       try{
//   const accessToken = localStorage.getItem("AccessToken-NonSSO");
//   const refreshToken =  localStorage.getItem("RefreshToken");

//     const data ={
//             "accessToken" : accessToken,
//             "refreshToken" : refreshToken
//          }

//     const headers = {
//         "Content-Type" : 'application/json',
//         "Authorization": accessToken as string
//       }
//      const response = await axios.post(MIDDLE_WARE_BASE_URL() + NON_SSO_LOGIN_REFRESH_TOKEN_API() , data, { headers : headers});

//      if(response?.data?.accessToken){
//         localStorage.setItem("AccessToken-NonSSO",  response?.data?.accessToken);
//         localStorage.setItem("RefreshToken", response?.data?.refreshToken);
//         const decodedToken: any = jwt_decode(response?.data?.accessToken);
//         localStorage.setItem("UserRole", decodedToken.userRole);
//     }
//        return Promise.resolve();
//     } catch (error) {
//         localStorage.removeItem("AccessToken-NonSSO");
//         localStorage.removeItem("RefreshToken");
//         localStorage.removeItem("UserRole");
//         window.location.reload();
//         return Promise.reject(
//             new Error('checkTokenValidity Something went wrong')
//         );
//     }
//     }
//    }
// }
//}

// export const checkTokenValidity = async (): Promise<any> => {
//     let res = new AADStorage();
//     var exp =res?.get()?.expiresOn?.valueOf();
//    if(exp){
//     const timeLeftMs: number = exp- new Date().valueOf();
//     const timeLeftMinutes = Math.round(timeLeftMs / 60000);
//     const hasSavedExpiredTokens = timeLeftMinutes <= 0;
//     const token = localStorage.getItem("AccessToken");

//     try {
//         if (hasSavedExpiredTokens) {
//           const accounts = JSON.parse(localStorage.getItem("AAD Account") || '{}');
//           const account=[];
//           account.push(accounts);
//           if(token){
//              await acquireTokenSilent(getInstance(),account, hasSavedExpiredTokens);
//           }
//             // this.setSelf(resultToken);
//             return Promise.resolve();
//         }

//         return Promise.resolve();
//     } catch (error) {
//         return Promise.reject(
//             new Error('checkTokenValidity Something went wrong')
//         );
//     }
// }
// };

/* Refresh Token */

const getTokenRequestHeaders = () => {
  return {
    headers: {
      Accept: "*/*",
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: localStorage.getItem("AccessToken"),
    },
  };
};

export const sendRefreshTokenRequest = async (grantType, refreshToken) => {
  const body = [];
  body.push(`grant_type=${grantType}`);
  body.push(`refresh_token=${refreshToken}`);

  const aadStogare = new AADStorage();

  return await axios
    .post(
      `https://identity.ttec.com/as/token.oauth2`,
      body.join("&"),
      getTokenRequestHeaders()
    )
    .then((response) => {
      if (response?.status !== 200) {
        return Promise.reject(
          new Error(
            "Invalid status code received in the token response: " +
              response?.status
          )
        );
      }
      const decodedToken = jwt_decode(response?.data?.access_token);

      localStorage.setItem(
        "AccessToken",
        "Bearer " + response?.data?.access_token + ""
      );
      localStorage.setItem(
        "RefreshToken",
        decodedToken.exp ? decodedToken.exp.toString() : ""
      );
      localStorage.removeItem("isRefreshTknCalled");
      window.location.reload();
      return Promise.resolve();
    })
    .catch((error) => {
      alert("Your session is expired.");
      //ClearStorage();
      aadStogare.clear();
      let logoutRequest = `https://accesshub-ppe.ttec.com/as/signoff?client_id=PPOR&post_logout_redirect_uri=${BASE_URL}`;
      window.location.href = logoutRequest;
      return Promise.reject(new Error("RefreshToken Something went wrong"));
    });
};

export const refreshToken = async () => {
  const token = localStorage.getItem("AccessToken");
  // console.log("refreshToken token", token);
  if (token) {
    const decodedToken = jwt_decode(token);
    if (decodedToken) {
      let date = new Date("1970-01-01 00:00:00:000");
      date.setSeconds(date.getSeconds() + decodedToken.exp);
      const dateString = date.toISOString();
      const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
      const localDate = new Date(dateString);
      const utcDate = new Date(localDate.getTime() - userOffset);
      const currentDate = new Date();
      const currentDateTime = new Date(
        currentDate.setMinutes(currentDate.getMinutes() + 5)
      );
      const tokenExpDateTime = new Date(utcDate);
      let isTokenExpired = currentDateTime >= tokenExpDateTime;
      if (
        isTokenExpired &&
        (localStorage.getItem("isRefreshTknCalled") === "false" ||
          localStorage.getItem("isRefreshTknCalled") === null)
      ) {
        try {
          // console.log("refreshToken isTokenExpired", isTokenExpired);
          localStorage.setItem("isRefreshTknCalled", "true");
          sendRefreshTokenRequest(
            "refresh_token",
            localStorage.getItem("RefreshToken")
          );
        } catch (error) {
          // console.log("refreshToken error", error);
          return Promise.reject(new Error("RefreshToken Something went wrong"));
        }
      }
    }
  }
};

export const isTokenExpired = (token) => {
  if (token) {
    const decodedToken = jwt_decode(token);
    if (decodedToken) {
      let date = new Date("1970-01-01 00:00:00.000");
      date.setSeconds(date.getSeconds() + decodedToken.exp);
      const dateString = date.toISOString();
      const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
      const localDate = new Date(dateString);
      const utcDate = new Date(localDate.getTime() - userOffset);
      const currentDateTime = new Date();
      const tokenExpDateTime = new Date(utcDate);
      return currentDateTime >= tokenExpDateTime;
    }
  }
  return false;
};

export const logout = () => {
  // Snapshot tokens BEFORE clearing localStorage — we need to pass id_token to PingOne
  // as id_token_hint (required for RP-initiated logout) and access_token for backend blacklisting.
  const idTokenRaw     = localStorage.getItem("IdToken");
  const accessTokenRaw = localStorage.getItem("AccessToken");
  const accessToken    = accessTokenRaw ? accessTokenRaw.replace(/^Bearer\s+/i, "") : "";

  // Fire-and-forget audit; don't await — we don't want logout blocked on a slow audit call.
  setLoginAudit(accessTokenRaw, "Logout");

  // Clear ALL auth-related keys. Missing any of these leaves the SPA in a half-authenticated
  // state and the next page load can silently re-auth via the Authorization interceptor.
  [
    "AccessToken",
    "AccessToken-NonSSO",
    "RefreshToken",
    "IdToken",
    "oracleId",
    "UserRole",
    "preferredName",
    "ShowWelcomeVideo",
    "isRefreshTknCalled",
  ].forEach((k) => localStorage.removeItem(k));

  // Null-guard df-messenger — it isn't always mounted (e.g. on error pages).
  const dfMessenger = document.querySelector("df-messenger");
  if (dfMessenger && typeof dfMessenger.clearStorage === "function") {
    dfMessenger.clearStorage();
  }

  // Build logout URL with both tokens. Backend reads them from query string and
  // forwards id_token as id_token_hint to PingOne /as/signoff.
  const params = new URLSearchParams();
  if (idTokenRaw) params.set("idToken", idTokenRaw);
  if (accessToken) params.set("accessToken", accessToken);

  // Use replace() not href — keeps logout out of browser history so back-button
  // can't return to an authenticated page.
  window.location.replace(BASE_URL + "api/logout?" + params.toString());
};
